export default __webpack_public_path__ + "static/media/Quote 2.7d3d7fd4.png";